import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const loadStatements = createAsyncThunk(
    'statements/loadStatements',
    async ({username, token}) => {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/user/statements/${username}`,
            {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            }
        )
        .then(response => response.json());
        return response;
    }
)


export const statementsSlice = createSlice({
    name: 'statements',
    initialState: {
        loadingStatements: false,
        failedToLoadStatements: false,
        statements: []
    },
    reducers: {
        clearStatements: (state) => {
            return {
                ...state,
                statements: []
            }
        }
    },
    extraReducers: {
        [loadStatements.pending]: (state) => {
            return {
                ...state,
                loadingStatements: true,
                failedToLoadStatements: false
            }
        },
        [loadStatements.fulfilled]: (state, action) => {
            return {
                ...state,
                loadingStatements: false,
                failedToLoadStatements: false,
                statements: action.payload
            }
        },
        [loadStatements.rejected]: (state) => {
            return {
                ...state,
                loadStatements: false,
                failedToLoadStatements: true
            }
        }
    }
})

export const statementsLoading = (state) => state.statements.loadingStatements;
export const loadStatementsFailed = (state) => state.statements.failedToLoadStatements;
export const statementDownloading = (state) => state.statements.downloadingStatement;
export const downloadStatementFailed = (state) => state.statements.failedToDownloadStatement;
export const selectStatements = (state) => state.statements.statements;

export const { clearStatements } = statementsSlice.actions;

export default statementsSlice.reducer;